// Might be to be moved, shared file for shared styled-components

import styled, { css } from "styled-components";
import { Table, TableRow } from "@mui/material";

import { EyeIcon, EyeSlashIcon } from "@/assets/icons";
import { breakpoints } from "@/styles/breakpoints";

export const StyledHeaderTitleBase = styled.h1`
    display: flex;
    align-items: center;
    font-size: var(--size-20);
    color: var(--color-primary);
    margin: 0;
    @media ${breakpoints.xs} {
        font-size: var(--size-14);
    }
`;

export const StyledHeaderSubtitleBase = styled.p`
    display: flex;
    align-items: center;
    font-size: var(--size-14);
    color: var(--color-grey-800);
    margin: 10px 0;
`;

export const StyledListEmpty = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 56px;
    font-size: var(--size-16);
    text-align: center;
    background: var(--color-grey-700);
    border-radius: var(--radius-10);
    opacity: 0.5;
`;

export const StyledEye = css`
    width: 22px;
    opacity: 0.5;
    cursor: pointer;
`;

export const StyledEyeSplashIcon = styled(EyeSlashIcon)`
    ${StyledEye}
`;

export const StyledEyeIcon = styled(EyeIcon)`
    ${StyledEye}
`;

export const StyledBaseEmail = styled.div`
    font-size: var(--size-16);
    font-weight: bold;
    line-height: 22px;
    color: var(--color-primary);
    text-align: center;
`;

export const StyledBlueBackground = styled.div<{ $disabled: boolean }>`
    box-sizing: border-box;
    width: 100%;
    padding: 16px;
    text-align: left;
    background-color: var(--color-secondary-light);
    border-radius: var(--radius-10);
    ${(props) =>
        props.$disabled &&
        `
            position: relative;
            pointer-events: none;
            opacity: 0.5;

            ::before {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                pointer-events: auto;
                content: "";
            }
        `}
`;

export const StyledBottomSheetButton = styled.span<{ $inline?: boolean; $hideDesktop?: boolean }>`
    display: ${(props) => (props.$hideDesktop ? "none" : "inline-block")};
    font-size: var(--size-12);
    color: var(--color-secondary);
    text-decoration: underline;
    cursor: pointer;

    @media ${breakpoints.xs} {
        display: ${(props) => (props.$inline ? "inline-block" : "block")};
    }
`;

StyledBottomSheetButton.defaultProps = {
    $inline: false,
    $hideDesktop: false,
};

export const StyledAdditionalInput = styled.div`
    display: flex;
    align-items: center;

    svg:last-child {
        margin-left: 5px;
        cursor: pointer;
    }
`;

export const StyledChipBase = styled.span`
    padding: 0 10px;
    font-size: var(--size-12);
    border-radius: var(--radius-20);
    color: var(--color-primary);
`;

export const StyledPendingChip = styled(StyledChipBase)`
    margin-right: 20px;
    background: var(--color-tertiary);
    color: var(--color-tertiary-fg);
`;

export const StyledDivider = styled.div`
    border-top: 1px solid var(--color-grey-700);
    width: 100%;
    margin: 15px 0;
`;

export const StyledCategoriesPanel = styled.div<{ $isLoading: boolean }>`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 15px;
    column-gap: 10px;
    @media ${breakpoints.xs} {
        grid-template-columns: 1fr 1fr;
    }
    opacity: ${(props) => (props.$isLoading ? "0.5" : "1")};
`;

export const StyledItemsPanel = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

// Table style

export const StyledFixedLayoutTable = styled(Table)`
    table-layout: fixed;
`;

export const StyledTableRow = styled(TableRow)`
    position: relative;
`;

export const StyledTableCellContainer = styled.div``;

export const StyledTableCellImg = styled.img`
    width: 30px;
    max-height: 40px;
    vertical-align: middle;
`;

export const StyledTableCellCategoryIcon = styled.div`
    height: 40px;
    width: 40px;

    svg {
        position: absolute;
        height: 34px;
        width: 34px;
        right: 0;
        bottom: 0;
    }
`;
